import Icon from '../AppIcon';

/**
 * Elegant badge indicating Article (مقال) or Discussion (حلقة نقاش).
 * Matches site aesthetic: Amiri font, warm gold for articles, sage for discussions.
 */
const ContentTypeBadge = ({ type, className = '', size = 'sm' }) => {
  const t = (type || 'Article').toString().toLowerCase();
  const isDiscussion = t === 'discussion';

  const config = isDiscussion
    ? {
        label: 'حلقة نقاش',
        icon: 'MessageCircle',
        classes: 'bg-success/10 text-success border-success/20',
      }
    : {
        label: 'مقال',
        icon: 'BookOpen',
        classes: 'bg-primary/10 text-primary border-primary/20',
      };

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium border ${sizeClasses} ${config.classes} ${className}`}
      style={{ fontFamily: 'Amiri, serif' }}
    >
      <Icon name={config.icon} size={size === 'sm' ? 10 : 12} className="flex-shrink-0" />
      {config.label}
    </span>
  );
};

export default ContentTypeBadge;
